import useFetch from 'use-http'
import { createGetUrl } from '../../utils'

export const usePost = ({ postId }) => {
  const response = useFetch(createGetUrl('ComunidadesCarregaPostUnico', postId), null, [postId])

  return response
}
